import React from 'react'
import { FiDelete, FiEdit, FiMoreHorizontal, FiMoreVertical, FiPlus, FiPrinter, FiTrash2, FiUserX } from 'react-icons/fi'
import Dropdown from '../shared/Dropdown'
import { Link } from 'react-router-dom'
import topTost from '../../utils/topTost'

const LeadsViewHeader = () => {
    const handleClick = () => {
        topTost()
    };

    return (
        <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
            
            
        </div>
    )
}

export default LeadsViewHeader